import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=2e81c658&scoped=true&"
import script from "./FileInput.vue?vue&type=script&lang=js&"
export * from "./FileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81c658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e81c658')) {
      api.createRecord('2e81c658', component.options)
    } else {
      api.reload('2e81c658', component.options)
    }
    module.hot.accept("./FileInput.vue?vue&type=template&id=2e81c658&scoped=true&", function () {
      api.rerender('2e81c658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/FileInput.vue"
export default component.exports